import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  private static readonly TTL_VALUE_KEY = '__value';
  private static readonly TTL_EXPIRES_AT_KEY = '__expiresAt';

  public setItem(key: string, value: string): void {
    localStorage.setItem(key, value);
  }

  public getItem(key: string): string {
    const stored = localStorage.getItem(key);
    if (!stored) {
      return '';
    }

    const parsed = this.parseTimedValue(stored);
    if (!parsed) {
      return stored;
    }

    if (parsed.expiresAt <= Date.now()) {
      localStorage.removeItem(key);
      return '';
    }

    return parsed.value;
  }

  public removeItem(key: string): void {
    localStorage.removeItem(key);
  }

  public clear(): void {
    localStorage.clear();
  }

  public setTimeItem(key: string, value: string, time = 20000): void {
    const ttlMs = Math.max(0, time);
    const expiresAt = Date.now() + ttlMs;
    const payload = JSON.stringify({
      [LocalStorageService.TTL_VALUE_KEY]: value,
      [LocalStorageService.TTL_EXPIRES_AT_KEY]: expiresAt,
    });

    localStorage.setItem(key, payload);

    if (ttlMs === 0) {
      localStorage.removeItem(key);
      return;
    }

    window.setTimeout(() => {
      if (localStorage.getItem(key) === payload) {
        localStorage.removeItem(key);
      }
    }, ttlMs);
  }

  private parseTimedValue(stored: string): { value: string; expiresAt: number } | null {
    try {
      const parsed = JSON.parse(stored) as Record<string, unknown>;
      const value = parsed[LocalStorageService.TTL_VALUE_KEY];
      const expiresAt = parsed[LocalStorageService.TTL_EXPIRES_AT_KEY];

      if (typeof value === 'string' && typeof expiresAt === 'number') {
        return { value, expiresAt };
      }
    } catch {
      return null;
    }

    return null;
  }
}
